import './howitworks.css'

function HowItWorks(){
    return (
        <div id="how-it-works">
            <h1>How It Works</h1>
            <iframe 
                src="https://www.youtube.com/embed/JDI6OlDdpGU?si=2mANarzhpSpLYXxX" 
                title="YouTube video player"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
            />
        </div>
    )
}

export default HowItWorks;
